import { render, staticRenderFns } from "./kvWorking.vue?vue&type=template&id=4202b04b&scoped=true&"
import script from "./kvWorking.vue?vue&type=script&lang=js&"
export * from "./kvWorking.vue?vue&type=script&lang=js&"
import style0 from "./kvWorking.vue?vue&type=style&index=0&id=4202b04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202b04b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4202b04b')) {
      api.createRecord('4202b04b', component.options)
    } else {
      api.reload('4202b04b', component.options)
    }
    module.hot.accept("./kvWorking.vue?vue&type=template&id=4202b04b&scoped=true&", function () {
      api.rerender('4202b04b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/static/kvWorking.vue"
export default component.exports